import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AutomaticUpdateModule } from '@features/automatic-update/automatic-update.module';
import { NavbarModule } from '@features/navbar/navbar.module';
import { LayoutModule } from '@lib/layout/layout.module';
import { IntroductionModule } from '@features/introduction/introduction.module';
import { DefaultLayoutComponent } from './default-layout.component';
import { FixedLayoutComponent } from './fixed-layout.component';

@NgModule({
  imports: [
    AutomaticUpdateModule,
    IntroductionModule,
    LayoutModule,
    NavbarModule,
    RouterModule,
  ],
  declarations: [FixedLayoutComponent, DefaultLayoutComponent],
  exports: [FixedLayoutComponent, DefaultLayoutComponent],
})
export class AppLayoutModule {}
